// extracted by mini-css-extract-plugin
export default {"segments_table_container":"SegmentsTableTemplate_segments_table_container__p8nLb","fadeInOut":"SegmentsTableTemplate_fadeInOut__M+q47"};